<template>
<div>
<v-container fluid class="mb-5">
    <v-row justify="space-between">
        <v-col cols="12" class="text-left d-flex align-center">
            <v-btn v-if="search_mode" class="mr-4" @click="$router.go(-1)">
            戻る</v-btn>
            <v-btn v-else color="" class="mygreen white--text mr-4" to="/patient">
            <img class="img" src="/img/icon_plus.svg" style="margin-left: -6px;margin-right:6px;width:20px;" />
                患者登録</v-btn>
            <!-- 患者検索ボタン -->
            <DialogPatientSearch @search="search" :isSameroute="true"></DialogPatientSearch>
        </v-col>
    </v-row>
</v-container>



  <v-data-table
    fixed-header
    :headers="headers"
    :items="records"
    :items-per-page="20"
    sort-by="calories"
    class="elevation-1"
    :height="tableHeight"
    v-resize="onResize"
    @click:row="rowClick"
  >

    <template v-slot:item.name="{ item }">
        <div v-html="item.name"></div>
    </template>

    <template v-slot:item.mail="{ item }">
      <v-btn
        @click.stop.prevent="toMail(item.id)"
      >
        メール
      </v-btn>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-btn
        @click.stop.prevent="editItem(item.id)"
      >
        登録
      </v-btn>
    </template>

    <template v-slot:no-data>
    データがありません.
    </template>


  </v-data-table>


</div>



</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import DialogPatientSearch from '@/components/DialogPatientSearch.vue';
import axios from 'axios';
import {mapGetters} from 'vuex';
/* eslint-disable */


  export default {

    components:{
        DialogPatientSearch
    },


    data(){
        return {
              // datas


              date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
              date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
              menu1: false,
              menu2: false,
              modal: false,


              title: '患者一覧',
              tableHeight: 700,
              dialog: false,
              dialogDelete: false,
              headers: [
                {
                  text: '診察券番号',
                  align: 'start',
                  value: 'bangou',
                },
                { text: '患者名', value: 'name' },
                { text: '固定電話番号', value: 'tel' },
                { text: '携帯電話番号', value: 'phone' },
                { text: '担当医', value: 'doctor' },
                { text: '担当スタッフ', value: 'staff' },
                { text: '最終来院日', value: 'last_come' },
              ],
              records: [],
              editedIndex: -1,
              editedItem: {
                name: '',
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0,
              },
              defaultItem: {
                name: '',
                calories: 0,
                fat: 0,
                carbs: 0,
                protein: 0,
              },

              search_mode: false,

              unit_selected: '',
              start_selected: '',
              end_selected: '',
              date_selected: '',

        }
    },  // datas


    computed: {
      ...mapGetters(['user', 'user_name', 'is_admin']),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
        console.log('%c created: PatientListView.vue', mycolor.created);

//      this.onResize();


    // 検索から来た場合
    if( this.$route.name==='patientlist_search' ){
      console.log( this.$route.name );
      this.search_mode = true;
      // 登録ボタンを出す
      this.headers.push(
            { text: '', value: 'actions', sortable: false },  // v-slot:item.actions と紐付いている
      );
    }


    if( this.$route.name==='patientlist_search_mail' ){
      console.log( this.$route.name );
      this.search_mode = true;
      // 登録ボタンを出す
      this.headers.push(
            { text: '', value: 'mail', sortable: false },  // v-slot:item.actions と紐付いている
      );
    }


    let data = this.$route.params.data;
    if( data ){
            console.log('患者検索から');
//            alert('患者検索から');
            console.log(data);

            this.unit_selected = data.unit;
            this.start_selected = data.start;
            this.end_selected = data.end;
            this.date_selected = data.date;

            axios.post('/patient_search', data)
              .then((res) => {
                    console.group();
                    console.log('%c/patient_search', mycolor.api);
                    console.log(res.data);
                    console.log('★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★');
                    console.log('パラメータあり');
                    console.groupEnd();

                    this.records = res.data;
              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });
    }else{
        console.log('パラメータなし');
        this.initialize();
    }



    },
    mounted () {
      console.log('mounted');
    },

    methods: {
        toMail (patient_id) {
            console.log('メール');
//            alert('メール');
            console.log(this.records);
            console.log(patient_id);


            this.$router.push({
                name: "mail_detail_new",
                params: {
                    'patient_id': patient_id,
                }      // 受け手側で this.$route.params で取得できる

            }).catch(()=>{});

            return false;
            /*
            this.editedIndex = this.records.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
            */
        },

        editItem (patient_id) {
            console.log('登録');
            console.log(this.records);
            console.log(patient_id);


            this.$router.push({
                name: "reserve",
                params: {
                    'patient_id': patient_id,
                    'unit': this.unit_selected,
                    'start': this.start_selected,
                    'end': this.end_selected,
                    'date': this.date_selected,

                }      // 受け手側で this.$route.params で取得できる

            }).catch(()=>{});

            return false;
        },

        search(data){

            console.log('%csearch()', mycolor.strong);
            console.log(data);

            axios.post('/patient_search', data)
              .then((res) => {
                console.log(res);
                    console.group();
                    console.log('%c/patient_search', mycolor.api);
                    console.log(res.data);
                    console.groupEnd();

                    this.records = res.data;
              })
              .catch( () => { console.error(); });
        },


        rowClick(v){
            console.log('rowClick');
            console.log(v);
            var api = '/patient/'+v.id;
            this.$router.push(api).catch(()=>{});
        },

      onResize() {
        console.log('onResize');
        console.log(this);
        this.tableHeight = window.innerHeight - 300;
      },


      // 初期化 todo:
      initialize () {
        console.log('initialize');

        console.log(this.$route);

        axios.get('/patient_list')
          .then((res) => {
            console.log(`%c/patient_list`, mycolor.orange);
            console.log(res);

            this.records = res.data;
            console.log('患者一覧取得完了');
            console.log(this.records);



          })
          .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
          });


        this.records = [];



      },


      deleteItem (item) {
        console.log(item);
        this.editedIndex = this.records.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.records.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.records[this.editedIndex], this.editedItem)
        } else {
          this.records.push(this.editedItem)
        }
        this.close()
      },
    },

  }
</script>


<style scoped>
/deep/ .kana{
    font-size: 9px;
}
/deep/ button.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default:hover {
    background-color: #8CC11E !important;
    border-color: #8CC11E !important;
    color: white;
}
</style>
